/* eslint-disable @typescript-eslint/no-explicit-any */

export const transformEmptyArrayToUndefined = (val: any): any | undefined =>
    !Array.isArray(val) || val.length > 0 ? val : undefined;
